<template>
    <b-form @submit.prevent="onSubmit">
      <!-- Name -->
      <b-form-group :label="$t('Name')" label-for="name">
        <b-form-input id="name" v-model="planData.name"
            autofocus :state="errors && ('name' in errors) ? false : null"
            trim autocomplete="off" placeholder=""
        />
        <b-form-invalid-feedback v-if="errors && ('name' in errors)"
                                 :state="errors && ('name' in errors) ? false : null">
          {{ errors.name[0]  }}
        </b-form-invalid-feedback>
      </b-form-group>


      <!-- device -->
      <b-form-group :label="$t('Device')" label-for="device" :state="null">
        <v-select v-model="planData.device_id"
                  label="name" :reduce="val => val.device_id"
                  :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" 
                  :options="devicesOptions"
                   :clearable="true" input-id="device"
        />

        <b-form-invalid-feedback v-if="errors && ('device_id' in errors)"
                                 :state="errors && ('device_id' in errors) ? false : null">
          {{ errors.device_id[0]  }}
        </b-form-invalid-feedback>
      </b-form-group>


      <b-row>
        <b-col cols="4">
          <!-- Camp -->
          <b-form-group :label="$t('Camp')" label-for="camp" :state="null">
            <v-select v-model="planData.camp_id" label="name"
                      :reduce="val => val.geofence_id"  :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" 
                      :options="campsOption" :clearable="false" input-id="camp"
            />
            <b-form-invalid-feedback v-if="errors && ('camp_id' in errors)"
                                     :state="errors && ('camp_id' in errors) ? false : null">
              {{ errors.camp_id[0]  }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <b-col cols="4">
          <!-- leave camp time -->
          <b-form-group :label="$t('Leave Camp Time')" label-for="leave-camp" :state="null">
            <flat-pickr v-model="planData.camp_leave"
                        class="form-control" :class="{ 'is-invalid' : errors && ('camp_leave' in errors) }"
                        :config="{...flatPickerConfig, defaultHour: 0, defaultMinute: 0}"
                        placeholder="HH:MM"
            />
            <b-form-invalid-feedback v-if="errors && ('camp_leave' in errors)"
                                     :state="errors && ('camp_leave' in errors) ? false : null">
              {{ errors.camp_leave[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <b-col cols="4">
          <!-- back camp time -->
          <b-form-group :label="$t('Back Camp Time')" label-for="back-camp" :state="null">
            <flat-pickr v-model="planData.camp_back" :state="null" class="form-control"
                        :class="{ 'is-invalid' : errors && ('camp_back' in errors) }"
                        :config="{...flatPickerConfig, defaultHour: 23, defaultMinute: 59}" placeholder="HH:MM:SS"
            />
            <b-form-invalid-feedback v-if="errors && ('camp_back' in errors)"
                                     :state="errors && ('camp_back' in errors) ? false : null">
              {{ errors.camp_back[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          
          <b-form-group :label="$t('work days')" label-for="work_days" :state="null">
            <b-form-checkbox-group
                v-model="planData.work_days"
                :options="daysOptions.map((i)=>({text:$t(i.text),value:i.value}))" name="flavour-1a">
            </b-form-checkbox-group>
            <b-form-invalid-feedback v-if="errors && ('work_days' in errors)"
                                     :state="errors && ('work_days' in errors) ? false : null">
              {{ errors.work_days[0]  }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <label>{{ $t('suction areas')}}</label>
          <area-form-repeater :items.sync="suctionAreaItems" :options="suctionAreaOption">
            <template v-slot:error>
              <b-form-invalid-feedback v-if="errors && ('suction_areas' in errors)"
                                       :state="errors && ('suction_areas' in errors) ? false : null">
                {{ errors.suction_areas[0] }}
              </b-form-invalid-feedback>
            </template>
          </area-form-repeater>
        </b-col>

        <b-col cols="6">
          <label>{{ $t('dump areas')}}</label>
          <area-form-repeater :items.sync="dumpAreaItems" :options="dumpAreaOption">
            <template v-slot:error>
              <b-form-invalid-feedback v-if="errors && ('dump_areas' in errors)"
                                       :state="errors && ('dump_areas' in errors) ? false : null">
                {{ errors.dump_areas[0] }}
              </b-form-invalid-feedback>
            </template>
          </area-form-repeater>
        </b-col>

      </b-row>

      <!-- Form Actions -->
      <div class="d-flex mt-2">
        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" type="submit">
          {{ $t('Save')}}
        </b-button>
      </div>
    </b-form>
</template>

<script>

import {
BCol, BRow, BFormGroup, BFormInvalidFeedback,BFormRadioGroup,BFormCheckboxGroup,
    BButton, BForm, BFormInput
} from 'bootstrap-vue'
import AreaFormRepeater from '@/components/form/AreaFormRepeater'
import { onUnmounted, ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import store from '@/store'
import formGetLinkedOptions from '@/views/modules/api/formGetLinkedOptions'

export default {
  name: 'RainPlanForm',
  props: ['errors','planData', 'suctionAreaItems','dumpAreaItems', 'onSubmit'],
  components: {
    AreaFormRepeater,BButton,BFormCheckboxGroup,
    flatPickr,vSelect, BForm, BFormInput,
    BCol, BRow, BFormGroup, BFormInvalidFeedback,BFormRadioGroup
  },
  directives: {
    Ripple,
  },
  setup() {

    const user = store.getters['auth/user']

    if (!store.hasModule('formOptions'))
      store.registerModule('formOptions', formGetLinkedOptions)

    onUnmounted(() => {
      if (store.hasModule('formOptions'))
        store.unregisterModule('formOptions')
    })

    const campsOption = ref([])
    const suctionAreaOption = ref([])
    const dumpAreaOption = ref([])
    const devicesOptions = ref([])


    const flatPickerConfig = {
      enableTime: true,
      noCalendar: true,
      time_24hr: true,
      dateFormat: "H:i:S",
    }


    const daysOptions = [
      { text: 'Saturday', value: 'Saturday' },
      { text: 'Sunday', value: 'Sunday' },
      { text: 'Monday', value: 'Monday' },
      { text: 'Tuesday', value: 'Tuesday' },
      { text: 'Wednesday', value: 'Wednesday' },
      { text: 'Thursday', value: 'Thursday' },
      { text: 'Friday', value: 'Friday' },
    ]


    const setOptions = area => {
      switch (area.category) {
        case 'CAMP_AREA': campsOption.value.push(area); break
        case 'WORK_AREA': suctionAreaOption.value.push(area); break
        case 'DUMP_AREA': dumpAreaOption.value.push(area); break
      }
    }

    store.dispatch('formOptions/getLinkedOptions', {
      user: user.id,
      type: 'geofence',
      cols: 'geofence_id,name,category'
    }).then(res => res.data.data.map(a => setOptions(a))).catch(reason => {})


    store.dispatch('formOptions/getLinkedOptions', {
      user: user.id,
      type: 'device',
      cols: 'device_id,name'
    }).then(res =>  devicesOptions.value = res.data.data ).catch(reason => {})


    return {
      daysOptions,
      flatPickerConfig,
      campsOption,
      dumpAreaOption,
      suctionAreaOption,
      devicesOptions
    }

  }
}
</script>

<style scoped>

</style>
